import { ApplicationConfig, ErrorHandler, PLATFORM_ID, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { GlobalErrorHandler } from './global-error-handler';
import { isPlatformBrowser } from '@angular/common';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore, initializeFirestore } from '@angular/fire/firestore';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { provideAppCheck, initializeAppCheck, ReCaptchaEnterpriseProvider } from '@angular/fire/app-check';
import { getApp } from 'firebase/app';
import { firebaseConfig, firestoreDatabaseId, environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideFirebaseApp(() => initializeApp(firebaseConfig)),
    provideAuth(() => getAuth()),
    provideFirestore(() => {
      const app = getApp();
      if (firestoreDatabaseId === '(default)') {
        return getFirestore(app);
      }
      return initializeFirestore(app, {}, firestoreDatabaseId);
    }),
    provideStorage(() => getStorage(getApp())),
    provideAppCheck((injector) => {
      if (!isPlatformBrowser(injector.get(PLATFORM_ID))) {
        return null as any; // App Check is browser-only — skip on SSR
      }
      if (!environment.appCheckSiteKey) {
        return null as any; // No reCAPTCHA site key configured — skip App Check
      }
      if (environment.appCheckDebugMode) {
        (globalThis as any).FIREBASE_APPCHECK_DEBUG_TOKEN = environment.appCheckDebugToken;
      }
      return initializeAppCheck(getApp(), {
        provider: new ReCaptchaEnterpriseProvider(environment.appCheckSiteKey),
        isTokenAutoRefreshEnabled: true,
      });
    }),
  ]
};
